import styled from "styled-components";

export const TabBarContainer = styled.div`
  display: flex;
  width: 90%;
  background-color: #fff;
  padding: 8px;
  border-radius: 16px;
  margin-bottom: 24px;
`;

export const ButtonContainer = styled.div`
  width: 50%;
  border-radius: 16px;
  padding: 8px;
  font-size: 11px;
  font-weight: ${(props) => (props?.isActive ? "bold" : "normal")};
  background-color: ${(props) =>
    props?.isActive ? props?.activeBgColor : "#fff"};
  color: ${(props) => (props?.isActive ? "#fff" : "#6A7481")};
`;
